import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiTransformersList, apiTransformersView } from 'Services/UserService'

export const getData = createAsyncThunk('user/transformers/getData', async datas => {
    const { data } = await apiTransformersList(datas)
    return data
})

export const getView = createAsyncThunk('user/transformers/getView', async datas => {
    var id = datas.id ? datas.id : datas.clone_id
    if (!id) return viewData
    const { data } = await apiTransformersView(id)
    data.summaries = data.summaries ?? []
    if (!datas.id) {
        ;['order_no', 'unit_no', 'serial_number'].map(key => {
            data[key] = ''
            return key
        })
    }
    return data
})

const viewData = {
    project_id: '',
    order_no: '',
    unit_no: '',
    serial_number: '',
    location_of_testing: 1,
    product_name: 1,
    condition_of_item: 1,
    transformer_type: 1,
    rating_selection: 1,
    place_of_inspection: 'Indotech Transformers limited, Kanchipuram',
    wdg_1_voltage_rating: 220,
    wdg_2_voltage_rating: 33,
    wdg_3_voltage_rating: 33,
    cooling_type_id_1: '',
    cooling_type_id_2: '',
    cooling_type_id_3: '',
    vector_group: 'YNyn0yn0',
    winding_1_2_vector: 'YNyn0',
    winding_1_3_vector: 'YNyn0',
    winding_2_3_vector: 'YNyn0',
    wdg_1_connection_type: 1,
    wdg_2_connection_type: 1,
    wdg_3_connection_type: 1,
    wdg_1_resistanc_unit: 1,
    wdg_2_resistanc_unit: 1,
    wdg_3_resistanc_unit: 1,
    wdg_1_resistanc_combination: ['ll'],
    wdg_2_resistanc_combination: ['ll'],
    wdg_3_resistanc_combination: ['ll'],
    wdg_1_sort_marking: 1,
    wdg_2_sort_marking: 4,
    wdg_3_sort_marking: 7,
    neutral_sort_marking: 8,
    wdg_1_marking: 1,
    wdg_2_marking: 4,
    wdg_3_marking: 7,
    neutral_marking: 8,
    winding_material_id: '',
    ref_temp_corrected: 75,
    wdg_co_efficient_constant: 235,
    phase_marking: 1,
    wdg_type: 1,
    rated_frequency: 1,
    wdg_1_first_rating: 126,
    wdg_1_second_rating: 168,
    wdg_1_third_rating: 210,
    wdg_2_first_rating: 63,
    wdg_2_second_rating: 84,
    wdg_2_third_rating: 105,
    wdg_3_first_rating: 63,
    wdg_3_second_rating: 84,
    wdg_3_third_rating: 105,
    no_of_phases: 1,
    reference_standard_id: '',
    wdg_1_phase_1_marking: '1.1',
    wdg_1_phase_2_marking: '1.2',
    wdg_1_neutral_marking: 'N',
    wdg_2_phase_1_marking: '2.1',
    wdg_2_phase_2_marking: '2.2',
    wdg_2_neutral_marking: 'N',
    wdg_3_phase_1_marking: '3.1',
    wdg_3_phase_2_marking: '3.2',
    wdg_3_neutral_marking: 'N',
    wdg_1_li_line: 1050,
    wdg_1_av_line: 38,
    wdg_1_iov_line: 460,
    wdg_1_li_neutral: 95,
    wdg_1_av_neutral: 38,
    wdg_2_li_line: 170,
    wdg_2_av_line: 70,
    wdg_2_iov_line: 66,
    wdg_2_li_neutral: 170,
    wdg_2_av_neutral: 70,
    wdg_3_li_line: 170,
    wdg_3_av_line: 70,
    wdg_3_iov_line: 66,
    wdg_3_li_neutral: 170,
    wdg_3_av_neutral: 70,
    wdg_1_li_si: 850,
    wdg_2_li_si: 850,
    wdg_3_li_si: 850,
    rating_oil_temp: 50,
    wdg_1_rating_temp: 55,
    wdg_2_rating_temp: 55,
    wdg_3_rating_temp: 55,
    wdg_1_voltage_varation: 1,
    wdg_1_pos_tap: 10,
    wdg_1_neg_tap: -10,
    wdg_1_tap_step: 1.25,
    wdg_1_tap_varation: 1,
    wdg_2_voltage_varation: 0,
    wdg_2_pos_tap: '',
    wdg_2_neg_tap: '',
    wdg_2_tap_step: '',
    wdg_2_tap_varation: '',
    wdg_3_voltage_varation: 0,
    wdg_3_pos_tap: '',
    wdg_3_neg_tap: '',
    wdg_3_tap_step: '',
    wdg_3_tap_varation: '',
    summaries: [],
}

export const transformersSlice = createSlice({
    name: 'user/transformers',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            status: 1,
            start: moment().startOf('year').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('year').locale('en').format('YYYY-MM-DD'),
            vector_group: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setVectorGroup: (state, { payload }) => {
            state.table.page = 1
            state.table.vector_group = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate, setVectorGroup } = transformersSlice.actions

export default transformersSlice.reducer
